import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { ExportButton } from '@ui/general/ExportButton';
import React from 'react';
import { stringifyObjectFilter } from './@arch/lib';
import { TimelineDetailsQueryParams } from './DetailsTable';

export interface DetailsExportButtonProps {
	disabled?: boolean;
	queryParams: TimelineDetailsQueryParams;
}

export const exportStartSelectors = createAsyncSelectors((state) => state.core.timeline.export.post);

export const DetailsExportButton: React.FC<DetailsExportButtonProps> = ({ disabled, queryParams }) =>
	<ExportButton
		buttonProps={ {
			id: 'timeline-details-export-button',
			type: 'default'
		} }
		disabled={ disabled }
		onStartExport={ coreActions.requestPostCoreTimelineExport }
		request={ {
			...queryParams,
			objectFilter: stringifyObjectFilter(queryParams.objectFilter ?? {})
		} }
		resetExport={ coreActions.resetPostCoreTimelineExport }
		stateSelector={ exportStartSelectors.state } />;

